import { Button, maxLength, required, TextInput, useNotify } from "react-admin";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import { erasmusRequests } from "api/erasmusApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import AttachmentInput from "server/components/Fields/AttachmentInput";

// onUploaded refreshes the attached-documents list (the record's useRefresh does not cover this
// separate GET), so it is awaited before the modal closes.
const UploadDocumentDialog = ({ id, onUploaded }) => {
  const notify = useNotify();

  const handleUpload = async data => {
    await dataProvider.customRequest(
      erasmusRequests.incomingStudentsRegularDocuments(id),
      { name: data.name, file: data.file },
      "POST",
      null,
      true,
    );
    notify("Документът е качен успешно", { type: "success" });
    await onUploaded();
  };

  return (
    <FormModal
      titleContent="Качване на документ"
      dialogSize="md"
      onConfirm={handleUpload}
      triggerButton={
        <Button
          label="Качи документ"
          variant="contained"
          startIcon={<UploadFileIcon />}
        />
      }
    >
      <TextInput
        source="name"
        label="Име на документа"
        fullWidth
        validate={[required(), maxLength(200)]}
      />
      <AttachmentInput
        source="file"
        label="Файл"
        isRequired
      />
    </FormModal>
  );
};

export default UploadDocumentDialog;
